import { FixedPageHeader } from './FixedPageHeader'
import { FixedPageBody } from './FixedPageBody'

export const FixedPage = {
  Header: FixedPageHeader,
  Body: FixedPageBody,
}
